import { CbhFeatureFlag } from "../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../FeatureFlags/useCbhFlag";

export function useIsJobInterviewsEnabled() {
  return useCbhFlag(CbhFeatureFlag.ROLLOUT_JOB_INTERVIEWS, {
    defaultValue: false,
  });
}
